import React, { useEffect, useState } from "react";

import Modal from "../../../Components/ExtraComponents/Modal";
import { useDispatch } from "react-redux";
import {
  Update_Comapny_Brokers,
} from "../../../ReduxStore/Slice/Superadmin/SuperAdminSlice";
import toast from "react-hot-toast";
import ToastButton from "../../../Components/ExtraComponents/Alert_Toast";

const Broker_Permittion = ({
  showModal,
  setshowModal,
  showPanelName,
  List,
  refresh,
  setRefresh
}) => {
  const dispatch = useDispatch();

  // const permission = JSON.parse(localStorage.getItem("permission"));
  const permission = List;


  // All available brokers
  const [GetAllBrokerName, setGetAllBrokerName] = useState([
    {
      id: "1",
      name: "Coin Dcx",
      title: "Coin Dcx",
    },
    {
      id: "2",
      name: "Delta Exchange",
      title: "Delta Exchange",
    },
    {
      id: "3",
      name: "Binance",
      title: "Binance",
    },
    {
      id: "4",
      name: "Zabpay",
      title: "Zabpay",
    },
    {
      id: "5",
      name: "Coinswitch",
      title: "Coinswitch",
    },
    {
      id: "6",
      name: "Pi42",
      title: "Pi42",
    },

  ]);


  // Currently selected brokers
  const [SelectedBrokers, setSelectedBrokers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Initialize selected brokers when modal opens
  useEffect(() => {
    if (showModal && List && List?.broker_id) {
      const initialSelectedBrokers = List?.broker_id.map((item) => ({
        id: item.id,
        name: item.name
      }));
      setSelectedBrokers(initialSelectedBrokers);
    }
  }, [showModal, List]);

  // useEffect(() => {
  //   if (showModal) {
  //     // Read permission from that specific panel
  //     const deltaPermission = permission?.trade_History_DeltaExchange == 1;

  //     if (deltaPermission) {
  //       const delta = GetAllBrokerName.find(
  //         (b) => b.name === "Delta Exchange"
  //       );
  //       if (delta) {
  //         setSelectedBrokers([{ id: delta.id, name: delta.name }]);
  //       }
  //       return;
  //     }

  //     // Normal selection
  //     if (List?.broker_id) {
  //       const initialSelectedBrokers = List?.broker_id.map((item) => ({
  //         id: item.id,
  //         name: item.name,
  //       }));
  //       setSelectedBrokers(initialSelectedBrokers);
  //     }
  //   }
  // }, [showModal, List]);


  // Check if a broker is currently selected


  const isBrokerSelected = (brokerId) => {
    return SelectedBrokers.some(
      (selectedBroker) => selectedBroker.id === brokerId
    );
  };

  // Handle checkbox change
  const handleBrokerChange = (event, broker) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      // Add broker to selected list
      setSelectedBrokers((prevSelected) => [
        ...prevSelected,
        { id: broker.id, name: broker.name || broker.title },
      ]);
    } else {
      // Remove broker from selected list
      setSelectedBrokers((prevSelected) =>
        prevSelected.filter((selectedBroker) => selectedBroker.id !== broker.id)
      );
    }
  };

  // Handle save button click
  const handleSave = async () => {
    if (SelectedBrokers.length === 0) {
      toast.error("Please select at least one broker");
      return;
    }

    setLoading(true);

    try {
      const req = {
        data: SelectedBrokers,
        domain: List.domain,
      };

      const response = await dispatch(Update_Comapny_Brokers(req)).unwrap();

      if (response.status) {
        toast.success(response.msg || "Brokers updated successfully");
        setRefresh((prev) => !prev);
        setshowModal(false);
        // Call parent component refresh function if available
        if (typeof showPanelName === 'function') {
          showPanelName();
        }
      } else {
        toast.error(response.msg || "Update failed");
      }
    } catch (error) {
      console.error("Error updating brokers:", error);
      toast.error(error?.message || "An error occurred while updating brokers");
    } finally {
      setLoading(false);
    }
  };

  // Handle select all brokers
  const handleSelectAll = () => {
    if (SelectedBrokers.length === GetAllBrokerName.length) {
      // Deselect all
      setSelectedBrokers([]);
    } else {
      // Select all
      setSelectedBrokers(
        GetAllBrokerName.map((broker) => ({
          id: broker.id,
          name: broker.name || broker.title,
        }))
      );
    }
  };

  // Handle modal close
  const handleClose = () => {
    if (loading) return; // Prevent closing while loading
    setshowModal(false);
    // Reset selected brokers to initial state
    if (List && List.id) {
      const initialSelectedBrokers = List.id.map((item) => ({
        id: item.id,
        name: item.name || item.title,
      }));
      setSelectedBrokers(initialSelectedBrokers);
    }
  };

  return (
    <div>
      <Modal
        isOpen={showModal}
        size="lg"
        title="Broker Permission"
        hideBtn={true}
        handleClose={handleClose}
      >
        <>
          {/* Header with Select All option */}
          <div className="row mb-3">
            <div className="col-6">
              <h6 className="mb-0">Select Brokers:</h6>
            </div>
            <div className="col-6 text-end">
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={handleSelectAll}
                disabled={loading}
              >
                {SelectedBrokers.length === GetAllBrokerName.length
                  ? "Deselect All"
                  : "Select All"}
              </button>
            </div>
          </div>

          {/* Broker Checkboxes */}
          <div className="row">
            {GetAllBrokerName &&
              GetAllBrokerName.map((broker) => (
                <div
                  className="col-lg-3 col-md-4 col-sm-6 my-2"
                  key={broker.id}
                >
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`broker_${broker.id}`}
                      name={`broker_${broker.id}`}
                      value={broker.id}
                      checked={isBrokerSelected(broker.id)}
                      onChange={(e) => handleBrokerChange(e, broker)}
                      disabled={
                        loading ||
                        (permission?.trade_History_DeltaExchange == 1 &&
                          broker.name !== "Delta Exchange")
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`broker_${broker.id}`}
                    >
                      {broker.title || broker.name}
                    </label>
                  </div>
                </div>
              ))}
          </div>

          {/* Selected Brokers Information */}
          <div className="row mt-3">
            <div className="col-12">
              <div className={`alert ${SelectedBrokers.length === 0 ? 'alert-warning' : 'alert-info'}`}>
                <small>
                  Selected Brokers: {SelectedBrokers.length} /{" "}
                  {GetAllBrokerName.length}
                </small>
                {SelectedBrokers.length > 0 && (
                  <div className="mt-1">
                    <strong>Selected:</strong>{" "}
                    {SelectedBrokers.map((broker) => broker.name).join(", ")}
                  </div>
                )}
                {SelectedBrokers.length === 0 && (
                  <div className="mt-1">
                    <small className="text-warning">
                      <i className="fas fa-exclamation-triangle me-1"></i>
                      Please select at least one broker to proceed.
                    </small>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="row mt-3">
            <div className="col-12 d-flex justify-content-end gap-2">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
                disabled={loading || SelectedBrokers.length === 0}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <i className="fas fa-save me-2"></i>
                    Save Changes
                  </>
                )}
              </button>
            </div>
          </div>

          <ToastButton />
        </>
      </Modal>
    </div>
  );
};

export default Broker_Permittion;